import { Series } from '@types';
import { LOCATIONS } from '@utils/locations';

const ARLES: Series = {
  id: 'arles',
  name: 'Arles',
  location: LOCATIONS.ARLES,
  groupBy: 'year',
  isZoneHighlight: true,
};

export default ARLES;
